<div class="modal-body" *ngIf="newUser">
  <div class="modal-header">
    <div class="lato-24-b-vw capitalize">Add User</div>
    <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'" (click)="activeModal.close()">
    </div>
  </div>
  <div class="modal-main">
    <div class="user-input-group">
      <div class="input-box">
        <label class="lato-18-n-vw capitalize" for="name">User Name</label>
        <input class="form-control" [(ngModel)]="newUser.name" id="name" placeholder="User Name"
          spellcheck="true" />
      </div>
      <div class="input-box">
        <label class="lato-18-n-vw capitalize" for="Email">User Email</label>
        <input class="form-control" [(ngModel)]="newUser.email" id="Email" placeholder="User Email"
          spellcheck="true" />
      </div>
    </div>
    <ng-container *ngIf="!fromVendor">
      <div class="user-input-group">
        <div class="select-group">
          <div class="input-box role">
            <label class="lato-18-n-vw capitalize" for="role">Role</label>
            <cygov-select id="role" [items]="roleOptions" placeholder="Select Role"
              [(ngModelValue)]="newUser.role" [clearable]="false">
            </cygov-select>
          </div>
        </div>
      </div>
      <div class="user-input-group">
        <div class="select-group">
          <div class="input-box entity-select">
            <label class="lato-18-n-vw capitalize" for="role">Leader Type</label>
            <cygov-select [disabled]="newUser.role !== roleEnum.LEADER" class="leader-type"
              [items]="leaderTypes" placeholder="Select" [(ngModelValue)]="leaderType">
            </cygov-select>
          </div>
          <div class="input-box entity-select">
            <cygov-select [disabled]="!showSubEntityList(newUser.role)" id="subEntity"
              class="leader-type" [items]="subEntityList" placeholder="Select Sub-Entity"
              bindLabel="name" bindValue="id" [(ngModelValue)]="selectedEntity">
            </cygov-select>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="user-input-group send-invite-btn">
      <button type="button" class="btn btn-primary uppercase" (click)="emitUser(newUser)">
        Send invitation
      </button>
    </div>
  </div>
</div>